<template>
    <div>
        <WaitingBlock v-if="isLoadingBoxes"></WaitingBlock>
        <BoxListEmptyCard v-else-if="(boxList==null || boxList.Count==0)"></BoxListEmptyCard>
        <div v-else>
            Lorem Ipsum Dolor Sit Amet : page index de la section Boxes : idéal pour mettre un petit tutorial
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    import router from '@/router/index.js'
    import Portlet from '@/components/common/Portlet'
    import { mapState } from 'vuex';
    import WaitingBlock from'@/components/common/WaitingBlock'
    import BoxListEmptyCard from './BoxListEmptyCard'

    export default {
        name: 'BoxIndex',
        router,
        components: { Portlet, BoxListEmptyCard, WaitingBlock },
        computed: {
            ...mapState({
                isLoadingBoxes: function () { return store.state.loadingStates.isLoadingStationBoxes },
                boxList: function () {
                    if (store.state.stationBoxes == null) { return null; }
                    var routeParam = this.$route.params.boxType;
                    console.log(routeParam);
                    return store.state.stationBoxes.items.filter(m => m.boxType === routeParam);
                }
            }),
        },
        methods: {
           
        }
    };
</script>

<style scoped>
</style>